import { useTranslation } from 'react-i18next'
import Select from 'react-select'
import styles from './StyledReactSelect.module.scss'

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '50px',
    border: '1px solid var(--color-black)',
    '&:hover, &:focus-within': {
      border: '2px solid var(--color-black)',
      boxShadow: 'var(--highlighted-box-shadow)',
    },
    ...(state.isFocused && {
      border: '2px solid var(--color-black)',
      boxShadow: 'var(--highlighted-box-shadow)',
    }),
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'var(--tertiary-color)' : base.backgroundColor,
    color: 'var(--color-black)',
    '&:hover, &:focus': {
      backgroundColor: 'var(--tertiary-color)',
    },
  }),
  noOptionsMessage: (base) => ({
    ...base,
    color: 'var(--color-black)',
    backgroundColor: 'var(--color-white)',
    fontSize: '1rem',
    padding: '10px',
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: 'var(--color-black)',
    borderRadius: '2px',
    padding: '2px',
    cursor: 'pointer',
    transition: 'background 0.2s ease, color 0.2s ease',
    '&:hover, &:focus': {
      backgroundColor: 'var(--error-color)',
      color: 'var(--color-black)',
    },
    ...(state.isFocused && {
      backgroundColor: 'var(--error-color)',
      color: 'var(--color-black)',
    }),
  }),
}

const StyledReactSelect = (props) => {
  const { t } = useTranslation()
  const { label } = props

  return (
    <div className={styles['container']} style={styles}>
      <span className={styles['label']}>{label}</span>
      <Select className={styles['select']} styles={props.styles} noOptionsMessage={() => t('form.select.noOptions')} {...props} />
    </div>
  )
}

export default StyledReactSelect
